import security from './SecurityService';
// @ts-ignore
import moment from "moment";

export default class UtilService {

    static clone(variable) {
        return JSON.parse(JSON.stringify(variable));
    }

    static async apiDownloadUrl(section, action, params={}) {
        let urlParams = this.serializeParams(params);
        if (!urlParams) {
            urlParams = "";
        }
        let me = await security.me();
        let apiKey = me.api_key;

        return "/api/?api_key="+apiKey+"&section="+section+"&action="+action+urlParams;
    }

    static extractCollection(o) {
        if (o instanceof Array) {
            return o;
        } else if (typeof o == 'undefined') {
            return [];
        } else {
            return [o];
        }
    }

    static unique(array){
        return array.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
    }

    static knowledgebaseUrl(docName = '') {
        return 'https://www.codereadr.com/knowledgebase/' + docName;
    }

    static codereadrUrl(docName = '') {
        return 'https://www.codereadr.com/' + docName;
    }

    static secureCodereadrUrl(docName = '') {
        return 'https://secure.codereadr.com/' + docName;
    }

    static exportTemplateFormulaUrl(docName = '') {
        return 'https://www.codereadr.com/solutions/' + docName;
    }

    static getDate(date, format) {
        if (!date || date === undefined) {
            return null;
        }
        let dt = date.replace('T',' ');
        let res = dt.slice(0, 19);
        return moment(res).format(format);
    }

    static getScript(source, callback) {
        let el = document.createElement('script');
        el.onload = callback;
        el.src = source;
        document.body.appendChild(el);
    }

    static serializeParams (obj = {}) {
        return Object.keys(obj).map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])).join('&');
    }
}
